<script setup>
import iconInstagramPath from '../../../../../../images/sns/icon_instagram.svg'
import iconFacebookPath from '../../../../../../images/sns/icon_facebook.svg'
import iconTwitterPath from '../../../../../../images/sns/icon_x.svg'
import {
  KkIcon,
  KkCheckbox
} from '../../../base'

const emit = defineEmits(['check', 'deselect'])

const props = defineProps({
  accounts: {
    type: Array,
    default: () => []
  },
  showDeselect: {
    type: Boolean,
    default: false
  },
  showCheck: {
    type: Boolean,
    default: false
  },
  isScrollable: {
    type: Boolean,
    default: false
  },
  checkIds: {
    type: Array,
    default: () => []
  }
})
const snsImage = (account) => {
  switch (account.type) {
  case 'facebook':
    return iconFacebookPath
  case 'instagram':
    return iconInstagramPath
  case 'twitter':
    return iconTwitterPath
  }
}

const deselect = (payload) => {
  emit('deselect', payload)
}
const check = (id) => {
  emit('check', id)
}

</script>

<template>
  <div class="wrapper" :class="{'is-scrollable': props.isScrollable}">
    <div v-for="(account, index) in props.accounts" :key="index" class="accountContainer">
      <KkCheckbox
        v-if="props.showCheck"
        :id="`${account.type}-${account.id}`"
        class="accountContainer__check"
        :model-value="props.checkIds.includes(`${account.type}-${account.id}`)"
        @change="check(`${account.type}-${account.id}`)"
      />
      <div class="accountContainer__images">
        <img alt="" :src="account.picture.url" class="accountContainer__thumbnail">
        <img alt="" :src="snsImage(account)" class="accountContainer__icon">
      </div>
      <div class="accountContainer__contents">
        {{ account.name }}
        <div class="accountContainer__pageId">@{{ account.username || account.appPageId }}</div>
      </div>
      <button v-if="props.showDeselect" class="accountContainer__deselect" type="button" @click="deselect({type: account.type, id: account.id})">
        <KkIcon name="delete" color="rgba(58, 59, 63, 0.7)" class="accountContainer__deselect__icon" />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.wrapper {
  border: 1px solid #E4E7EB;
  border-radius: 4px;
  margin-bottom: 16px;
  &.is-scrollable {
    max-height: 340px;
    overflow-y: scroll;
  }
}
.accountContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 68px;
  padding: 12px;
  border-top: 1px solid #E4E7EB;
  &:first-child {
    border-top: 0px;
  }
  margin: 0;
  &__check {
    margin-right: 8px;
  }
  &__images {
    position: relative;
    margin-right: 12px;
    img{
      border-radius: 50%;
    }
  }
  &__thumbnail {
    width: 36px;
    height: 36px;
    object-fit: cover;
  }
  &__icon {
    position: absolute;
    width: 18px;
    height: 18px;
    bottom: 0;
    left: 60%;
    bottom: 10%;
    background: #fff;
    border: solid 1px #fff;
  }
  &__contents {
    font-size: 14px;
  }
  &__pageId {
    font-size: 12px;
    color: #9e9e9e;
  }
  &__connectedUserName {
    margin-left: auto;
    color: #9e9e9e;
  }
  &__deselect {
    display: flex;
    align-items: center;
    margin-left: auto;
    &__icon {
      width: 16px;
      margin-right: 5px;
    }
  }
}
</style>
